module.exports = __webpack_public_path__ + "static/media/addcredit.7b37fe8a.jpg";